var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcResetBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB4\x88\xEA\xB8\xB0\xED\x99\x94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8138 11.3398H17.4824C17.226 14.9721 14.1974 17.8398 10.5 17.8398C6.63448 17.8398 3.5 14.7054 3.5 10.8398C3.5 6.97432 6.63448 3.83984 10.5 3.83984C12.437 3.83984 14.1858 4.62494 15.4454 5.89231L15.7989 6.24804L16.1536 5.8934L17.5 4.54695V8.67318H13.3738L14.9786 7.0684L15.3335 6.71344L14.9772 6.3599C13.8305 5.22222 12.2475 4.50651 10.5 4.50651C7.00719 4.50651 4.16667 7.34703 4.16667 10.8398C4.16667 14.3327 7.00719 17.1732 10.5 17.1732C13.8245 17.1732 16.5581 14.5997 16.8138 11.3398Z",
    fill: "black",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResetBl);
export default __webpack_public_path__ + "static/media/ic_reset_bl.35eb6e6d6d5a3eadd150b8d53c4f05ad.svg";
export { ForwardRef as ReactComponent };